import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {UrlService} from '../../services/url.service';
import {ParkingPassService} from '../../services/parking-pass.service';
import {AuthenticationService} from '../../services/authentication.service';
import {ResidentService} from '../../services/resident.service';
import {flatMap, takeUntil, tap} from 'rxjs/operators';

@Component({
    templateUrl: 'parking-pass.component.html',
    styleUrls: ['parking-pass.component.scss']
})
export class ParkingPassComponent implements OnInit, OnDestroy {
    currentMonth: any;

    constructor(
        public parkingPassService: ParkingPassService,
        public urlService: UrlService,
        public authenticationService: AuthenticationService,
        public residentService: ResidentService,
    ) {
    }

    ngOnInit() {
        const selectedBuilding = JSON.parse(localStorage.getItem('residentselectedBuilding'));
        this.urlService.onUrlChange
            .pipe(
                tap(() => this.parkingPassService.tabId = this.urlService.queryParams['tab']),
                flatMap(() => this.parkingPassService.getDataByQueryParams(true)
                    .pipe(takeUntil(this.urlService.instantOnUrlChange))
                )
            )
            .subscribe();
        this.urlService.setQueryParams('allParkingPasses');

        if (selectedBuilding) {
            this.getCurrentMonth();

            this.parkingPassService.residentParkinglots = [];
            this.residentService.getResidentLots(selectedBuilding.buildingId);
        } else {
            this.parkingPassService.getBuildings();
        }

    }

    ngOnDestroy() {
        this.removeAllObservers();
        this.parkingPassService.resetData();
        this.urlService.resetQueryParams();
    }

    removeAllObservers() {
        this.urlService.onUrlChange.observers = [];
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.parkingPassService.emptyRowService.fillEmptyRow();
    }

    getCurrentMonth(): void {
        const date = new Date();
        const number = date.getUTCMonth();
        const month = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ];
        this.currentMonth = month[number];
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/parking-pass/parking-pass.component.ts